"use client";

import { ThemeProvider } from "styled-components";
import { isMobileLayout } from "../mono/lib/responsive";
import StyledComponentsRegistry from "../mono/components/StyledComponentsRegistry";
import { useMemo, useState } from "react";
import useEvent from "../mono/lib/hooks/useEvent";
import * as theme from "../common/theme";
import { events } from "../common/constants";
import { create } from "zustand";
import { themeTransition } from "../mono/lib/styles/globalStyles";

export function ThemeWrapper({ children }) {
  const lightTheme = useMemo(() => {
    return { ...theme, theme: theme.lightTheme };
  }, []);

  const darkTheme = useMemo(() => {
    return { ...theme, theme: theme.darkTheme };
  }, []);

  const pinkTheme = useMemo(() => {
    return { ...theme, theme: theme.pinkTheme };
  }, []);

  const [currentTheme, setTheme] = useState(lightTheme);

  useEvent(events.SWITCH_THEME, (t) => {
    setTheme(t === "light" ? lightTheme : t === "dark" ? darkTheme : pinkTheme);

    // Temporarily enable global theme transitions
    const root = document.documentElement;
    root.classList.add("theme-transitioning");
    if (window.__themeTransitionTO)
      window.clearTimeout(window.__themeTransitionTO);
    window.__themeTransitionTO = window.setTimeout(() => {
      root.classList.remove("theme-transitioning");
    }, themeTransition.duration + 50);
  });

  return (
    <StyledComponentsRegistry>
      <ThemeProvider
        theme={{
          ...currentTheme,
          //   locale: router.locale,
          locale: "EN",
          isMobileLayout: isMobileLayout(),
        }}
      >
        {children}
      </ThemeProvider>
    </StyledComponentsRegistry>
  );
}
